import React from "react";
import { getDevdocsNavItems, NavItem } from "../../shared/config/navigation";
import { getPlatformUrl } from "../../shared/config/urls";

interface ZudokuNavigationProps {
  navItems?: NavItem[];
}

export const ZudokuNavigation: React.FC<ZudokuNavigationProps> = ({
  navItems: _navItems = [],
}) => {
  // Use shared navigation configuration with proper cross-site URLs
  const publicNavItems = getDevdocsNavItems();

  return (
    <nav className="flex flex-col gap-2 md:flex-row md:items-center md:space-x-6">
      <div className="flex h-14 sm:h-16 items-center justify-between">
        <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:space-x-4">
          {/* Platform link - only show when authenticated */}
          <a
            href={`${getPlatformUrl()}/platform/get-started`}
            className="relative text-sm font-medium transition-colors hover:text-foreground text-muted-foreground"
            style={{ fontWeight: 500 }}
          >
            Platform
          </a>

          {/* Navigation Items */}
          {publicNavItems.map((item, index) => {
            // On the devdocs site, the only internal nav item is "Dev Docs"
            // Mark internal items as active deterministically to avoid SSR/client mismatch
            const isActiveItem = !("external" in item && item.external);

            if (item.external) {
              return (
                <a
                  key={index}
                  href={item.path}
                  className={`relative text-sm font-medium transition-colors hover:text-foreground mr-0 md:mr-4 mb-1 md:mb-0 ${
                    isActiveItem ? "text-foreground" : "text-muted-foreground"
                  }`}
                  style={{ fontWeight: 500 }}
                >
                  {item.name}
                  {isActiveItem && (
                    <div className="absolute -bottom-4 left-0 right-0 h-0.5 bg-primary"></div>
                  )}
                </a>
              );
            }

            return (
              <a
                key={index}
                href={item.path}
                className={`relative text-sm font-medium transition-colors hover:text-foreground mr-0 md:mr-4 mb-1 md:mb-0 ${
                  isActiveItem ? "text-foreground" : "text-muted-foreground"
                }`}
                style={{ fontWeight: 500 }}
              >
                {item.name}
                {isActiveItem && (
                  <div className="absolute -bottom-4 left-0 right-0 h-0.5 bg-primary"></div>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
